import React from "react";
import "../styles/Blog.css";

const Blog = () => {
  const posts = [
    {
      title: "Post 1",
      date: "March 1, 2023",
      excerpt: "This is a brief excerpt of Post 1.",
    },
    {
      title: "Post 2",
      date: "March 15, 2023",
      excerpt: "This is a brief excerpt of Post 2.",
    },
    {
      title: "Post 3",
      date: "April 1, 2023",
      excerpt: "This is a brief excerpt of Post 3.",
    },
  ];

  return (
    <section id="blog" className="blog">
      <h2>Blog</h2>
      <div className="blog-posts">
        {posts.map((post, index) => (
          <div key={index} className="blog-post">
            <h3>{post.title}</h3>
            <p className="date">{post.date}</p>
            <p className="excerpt">{post.excerpt}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog;
